import { Injectable } from '@angular/core';
import { fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { EquipmentDetails } from 'src/app/models/domain/equipment-details';
import { YPMCONSTRUCTIONVCDSYPMEQUIPMENTVType } from 'src/generated-clients/equipment';

@Injectable({
  providedIn: 'root',
})
export class EquipmentAdapter implements IAdapter<
  EquipmentDetails,
  YPMCONSTRUCTIONVCDSYPMEQUIPMENTVType
> {
  public adaptToDomain(item: YPMCONSTRUCTIONVCDSYPMEQUIPMENTVType): EquipmentDetails {
    return new EquipmentDetails(
      fallbackString(item.equipmentNumber),
      fallbackString(item.equipmentCategory),
      fallbackString(item.equipmentDescription),
      fallbackString(item.equipmentStatus),
      fallbackString(item.equipmentType),
      fallbackString(item.equipmentTypeText),
      Number(item.weightOfObject),
      fallbackString(item.unitOfWeight),
      Number(item.aquisitionValue),
      fallbackString(item.currencyKey),
      fallbackString(item.manufacturer),
      fallbackString(item.manufacturerSerialNumber),
      fallbackString(item.maintenancePlant),
      fallbackString(item.maintenancePlantText),
      fallbackString(item.location),
      fallbackString(item.locationtext),
      fallbackString(item.room),
      fallbackString(item.costCenter),
      fallbackString(item.costCenterShortName),
      fallbackString(item.costCenterLongName),
      fallbackString(item.controllingArea),
      fallbackString(item.wbsElement),
      fallbackString(item.wbsElementDescription),
      fallbackString(item.settlementOrder),
      fallbackString(item.maintenancePlanningPlant),
      fallbackString(item.maintenancePlanningPlantText),
      fallbackString(item.plannerGroup),
      fallbackString(item.plannerGroupText),
      fallbackString(item.superOrdinateEquipment),
      fallbackString(item.constructionId),
      fallbackString(item.designId),
      fallbackString(item.mainiGroupId),
      fallbackString(item.mainGroupDescription),
      fallbackString(item.receivingPlant),
      fallbackString(item.receivingPlantText),
      fallbackString(item.statusCode),
      fallbackString(item.cleaningInterval),
      fallbackString(item.lastCleaning),
      fallbackString(item.budgetShots),
      fallbackString(item.actualNumberOfElements),
      fallbackString(item.oldMachineNumber),
      fallbackString(item.mouldBudgetYear),
      fallbackString(item.mouldBoxInclInPrice),
      fallbackString(item.additionalLocation),
      fallbackString(item.cleaningWeek),
      fallbackString(item.sysCleaningPct),
      fallbackString(item.SPPH),
      fallbackString(item.objectNumber),
      fallbackString(item.changeTime)
    );
  }
}
